// @flow
import moment from 'moment';
import type { ComponentType } from 'react';
import React from 'react';
import { MdClearAll } from 'react-icons/lib/md';

import styles from './notificationElementDummy.css';
import stylesHighlight from '../DataTable/Cells/Highlight/highlightCell.css';


type NotificationElementDummyPropTypes = {
  Icon?: ComponentType<*>,
  pictureURL?: string,
  title?: string,
  // description?: string,
  date?: string,
  onSelect?: Function,
  isRead?: boolean,
  isSelected?: boolean,
  isOpen?: boolean
};

const NotificationElementDummy = ({
  title = '',
  // description = '',
  date = '',
  onSelect,
  isRead = false,
  pictureURL,
  Icon,
  isSelected = false,
  isOpen = false,
}: NotificationElementDummyPropTypes) => (
  <div
    onClick={onSelect}
    className={
      `
        ${styles.container}
        ${styles.medium}
        ${isSelected ? styles.selected : ''}
        ${isRead ? styles.read : ''}
        ${isOpen ? styles.open : ''}
        ${styles.alternateEvenly}
      `
    }
    role="presentation"
  >
    {
      typeof Icon !== 'undefined'
        && (
          <div className={styles.iconContainer}>
            <Icon />
          </div>
        )
    }

    { typeof pictureURL !== 'undefined' && <img src={pictureURL} alt="" /> }
    <div className={styles.data}>
      <div className={`
        ${stylesHighlight.highlight}
        ${styles.title}
      `}>
        { title }
      </div>
      <div className={styles.date}>
        { moment(date).format('LL') }
      </div>
    </div>
    <div
      className={
        `
          ${styles.iconContainer}
          ${styles.remove}
        `
      }
    >
      <MdClearAll />
    </div>
  </div>
);

export default NotificationElementDummy;



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationElementDummy/index.jsx